import { load } from 'recaptcha-v3';

class Recaptcha3 {
	static async getSubmitToken() {
		const recaptcha = await load('6LcYbhIcAAAAAGvs_OlvwsiNXaKNHktF_-dUzLTM');
		const token = await recaptcha.execute('submit');

		return token;
	}
}

export default Recaptcha3;